module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Vamos começar","heading":"Que tipo de acervo está criando?","paragraph":"Escolha se esta conta será para gerir um acervo pessoal e familiar ou de uma comunidade (escolas, empresas etc.)"}}')
  delete Component.options._Ctor
}
